import { UsersService } from './../services/users.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FormGroup, FormBuilder, Validators, } from '@angular/forms';
import { PasswordValidation } from '../password-validation/password-validation.component';

@Component({
	selector: 'app-renew-password',
	templateUrl: './renew-password.component.html',
	styleUrls: ['./renew-password.component.scss']
})
export class RenewPasswordComponent implements OnInit {
	@BlockUI() blockUI: NgBlockUI;

	token: string;
	form: FormGroup;
	inputPwdFocus: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private usersService: UsersService,
		private toastrService: ToastrService,
		private router: Router,
		private formBuilder: FormBuilder,
	) { }

	ngOnInit(): void {
		this.token = this.route.snapshot.params['token'];
		this.form = this.formBuilder.group({
			oldPassword: ['', Validators.required],
			password: ['', Validators.required],
			confirmedPassword: ['', Validators.required]
		}, {
			validator: PasswordValidation.MatchPassword
		});
	}

	resetPwd(): void {
		if (this.form.controls.password.value === this.form.controls.confirmedPassword.value) {
			this.blockUI.start('Loading');

			this.usersService.resetCorePassword(this.token, this.form.controls.password.value).subscribe(
				(res) => {
					if (res.success) {
						this.toastrService.success("Le nouveau mot de pass est crée");
						this.router.navigate(['/bo/connexion']);
						this.blockUI.stop();
					} else {
						this.blockUI.stop();
						if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
							this.toastrService.error('Les paramètres sont invalides');
						} else if (res.errorSet.includes('TOKEN_ERROR')) {
							this.toastrService.error("Token est incorrecte ou expiré");
						} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
							this.toastrService.error('Une erreur serveur est survenue');
						}
					}
				},
				(error) => {
					this.blockUI.stop();
					// console.error(error);
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		}
		else {
			this.toastrService.error("Mot de passe n'est pas le même");
		}
	}
}
